<script setup lang="ts"></script>

<template>
  <header id="header" role="banner" class="fr-header">
    <div class="fr-header__body">
      <div class="fr-container">
        <div class="fr-header__body-row">
          <div class="fr-header__brand">
            <div class="fr-header__brand-top">
              <div class="fr-header__logo">
                <img src="https://audits.aplusb.pro/dist/images/logo-aplusb-dark.svg" alt="AplusB" style="height: 8vh"/>
              </div>
            </div>  
            <div class="fr-header__service">
              <p class="fr-header__service-title">
                Aram
                <span
                  class="fr-badge fr-badge--sm fr-badge--info fr-badge--no-icon"
                  >ALPHA</span
                >
              </p>
              <p class="fr-header__service-tagline">
                Réalisez vos audits d’accessibilité numérique d'applications mobiles
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.user-dropdown {
  text-align: initial !important;
}
</style>
